import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shared-brasao-ms',
  templateUrl: './shared-brasao-ms.component.html'
})
export class SharedBrasaoMsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
